import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import {
  useRefresh,
  useNotify,
  useMutation,
  Button,
  useDataProvider,
  FormWithRedirect,
} from "react-admin";
import SaveIcon from "@material-ui/icons/Save";
import { useFormState } from "react-final-form";
import SanitizedGrid from "../../../components/SanitizedGrid";
import InternalNoteInput from "components/InternalNoteInput";
import { StyledButton } from "../../../components/ListShowButton";

interface IInternalNoteParentButton {
  parentId: string;
}

const CustomConfirmButton = ({ parentId }: IInternalNoteParentButton) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const { values } = useFormState();

  const [handleUpdateNoteParent, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `parents/${parentId}/note`,
      payload: {
        data: {
          ParentId: Number(parentId),
          Note: values.internalNote?.value,
        },
      },
    },
    {
      onSuccess: () => {
        notify(`Successfully update note parent.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed update note the parent, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleUpdateNoteParent}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

const InternalNoteParentButton = ({ parentId }: IInternalNoteParentButton) => {
  const [parent, setParent] = useState<IParent>();
  const [open, setOpen] = useState<boolean>(false);
  const classes = useStyles();
  const provider = useDataProvider();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getParent = (parentId: number) => {
    provider.getOneAxios("parents", { id: parentId }).then((data: any) => {
      setParent(data.data);
    });
  };

  useEffect(() => {
    if (open) {
      getParent(Number(parentId));
    }
  }, [open]);

  return (
    <Fragment>
      <StyledButton variant="outlined" onClick={handleOpenDialog}>
        Internal Note
      </StyledButton>

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        fullWidth
      >
        <FormWithRedirect
          render={() => (
            <form>
              <DialogTitle id="alert-dialog-title">
                Internal Note Parent
              </DialogTitle>
              <DialogContent>
                <SanitizedGrid container spacing={2}>
                  <Grid item xs={12}>
                    <InternalNoteInput record={parent} />
                  </Grid>
                </SanitizedGrid>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="secondary" label="Back" />
                <CustomConfirmButton parentId={parentId} />
              </DialogActions>
            </form>
          )}
        />
      </Dialog>
    </Fragment>
  );
};

export default InternalNoteParentButton;
